jQuery(document).ready(function(){
  jQuery('.back-to-collection-wrapper').remove()
	jQuery("#customMenuToggle").on("click", function(e){
		e.preventDefault();
		if(jQuery(this).hasClass("active"))
		{
			jQuery(".mobile-menu-wrapper").slideUp();
			jQuery(this).removeClass("active");
		}
		else
		{
			jQuery(".mobile-menu-wrapper").slideDown();
			jQuery(this).addClass("active");
		}
	});
	if(jQuery(".custom-header-wrapper.custom-header-sticky").length) 
	{
    	var headerHeight = jQuery(".custom-header-wrapper.custom-header-sticky").outerHeight();
    	if(typeof headerHeight != "undefined" && headerHeight != null && headerHeight != "")
    	{
      		jQuery(".custom-header-fix").removeAttr("style");
      		jQuery(".custom-header-fix").css("height", headerHeight+"px");
		}
	}
	jQuery(".collection-add-to-cart-button-js").on("click", function(e){
		e.preventDefault();
		var currentVariantId = jQuery.trim(jQuery(this).attr("data-variant-id"));
		var currentElement = jQuery(this);
		if(typeof currentVariantId != "undefined" && currentVariantId != null && currentVariantId != "")
		{
			jQuery(currentElement).removeClass("added");
			jQuery(currentElement).addClass("loading");
			var custom_single_items = {items:[]};
			var single_element = {
          id: currentVariantId,
          quantity: 1
        }
      custom_single_items.items.push(single_element);
			jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: custom_single_items,
          success: function(success_data) {
            jQuery(currentElement).removeClass("loading");
            jQuery(currentElement).addClass("added");
            jQuery.ajax({
			        url: '/cart.js',
			        dataType: "json",
			        cache: false,
			        success: function(cart) {
			          if(cart.item_count > 0)
			          {
			          	jQuery(".header-cart-count").html("");
			          	jQuery(".header-cart-count").html(cart.item_count);
			          	jQuery(".header-cart-count").removeClass("empty");
			          }
			          else
			          {
			          	jQuery(".header-cart-count").html("");
			          	jQuery(".header-cart-count").html(cart.item_count);
			          	jQuery(".header-cart-count").addClass("empty");
			          }
			        }
			      });
          },
          error: function(data) {
              jQuery(currentElement).removeClass("loading");
              alert(data.responseJSON.description);
          }
      });
		}
	});
});
jQuery(window).on("resize", function () {
  	if(jQuery(".custom-header-wrapper.custom-header-sticky").length) 
  	{
    	setTimeout(function(){
      		var headerHeight = jQuery(".custom-header-wrapper.custom-header-sticky").outerHeight();
      		if(typeof headerHeight != "undefined" && headerHeight != null && headerHeight != "")
      		{
        		jQuery(".custom-header-fix").removeAttr("style");
        		jQuery(".custom-header-fix").css("height", headerHeight+"px");
      		}
    	}, 500);
  }
});
jQuery(window).on("load", function () {
  	if(jQuery(".custom-header-fix").length)
  	{
    	var headerHeight = jQuery(".custom-header-wrapper.custom-header-sticky").outerHeight();
    	if(typeof headerHeight != "undefined" && headerHeight != null && headerHeight != "")
    	{
      		jQuery(".custom-header-fix").removeAttr("style");
      		jQuery(".custom-header-fix").css("height", headerHeight+"px");
    	}
  }
});
jQuery(window).on("scroll", function () {
 	var scroll = jQuery(window).scrollTop();
  	if (scroll > 0) 
  	{
    	jQuery(".custom-header-wrapper").addClass("is_sticky");
  	} 
  	else 
  	{
    	jQuery(".custom-header-wrapper").removeClass("is_sticky"); 
  	}
});



var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}